export enum StandardValueType {
    TEXT = 'TEXT',
    AMOUNT = 'AMOUNT',
    COUNTER = 'COUNTER',
    PERCENTAGE = 'PERCENTAGE',
    DATE = 'DATE',
    PHONE = 'PHONE',
    IBAN = 'IBAN',
}
export const emptyValue = '-';

